var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { BrowserSupportService } from '../utils/browser-support.service';
import { isRtl } from '@progress/kendo-react-data-tools';
/**
 * @hidden
 */

var Header = function (_super) {
  __extends(Header, _super);

  function Header() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.divStyle = {};
    _this.element = null;
    _this.headerWrap = null;
    _this.table = null;
    _this.syncScroll = false;

    _this.onScroll = function (_event) {
      if (_this.syncScroll) {
        _this.syncScroll = false;
        return;
      }

      if (!_this.headerWrap) {
        return;
      }

      var scrollLeft = _this.headerWrap.scrollLeft;

      var scrollableDataElement = _this.props.scrollableDataElement();

      if (scrollableDataElement && scrollableDataElement.scrollLeft !== scrollLeft) {
        scrollableDataElement.scrollLeft = scrollLeft;
      }
    };

    return _this;
  }

  Header.prototype.componentDidMount = function () {
    var rtl = isRtl(this.element);

    if (this.props.columnResize) {
      this.props.columnResize.setIsRtl(rtl);
    }

    var scrollbarWidth = new BrowserSupportService().scrollbarWidth;
    var padding = Math.max(0, scrollbarWidth) + 'px';
    var right = rtl ? 0 : padding;
    var left = rtl ? padding : 0;
    this.divStyle = {
      padding: "0 " + right + " 0 " + left
    };
    this.forceUpdate();
  };
  /**
   *
   * @param scrollLeft - Scrolls to the left (in pixels).
   */


  Header.prototype.setScrollLeft = function (scrollLeft) {
    if (this.headerWrap && this.headerWrap.scrollLeft !== scrollLeft) {
      this.syncScroll = true;
      this.headerWrap.scrollLeft = scrollLeft;
    }
  };
  /**
   *
   * @param width - Scrolls the width (in pixels).
   */


  Header.prototype.setWidth = function (width) {
    if (this.table) {
      this.table.style.width = width + 'px';
    }
  };

  Header.prototype.render = function () {
    var _this = this;

    if (!this.props.staticHeaders) {
      return React.createElement("thead", {
        className: "k-grid-header"
      }, this.props.headerRow, this.props.filterRow);
    }

    return React.createElement("div", {
      ref: function ref(div) {
        _this.element = div;
      },
      className: "k-grid-header",
      style: this.divStyle,
      role: "presentation"
    }, React.createElement("div", {
      ref: function ref(div) {
        _this.headerWrap = div;
      },
      className: "k-grid-header-wrap",
      onScroll: this.onScroll,
      role: "presentation",
      style: {
        borderWidth: 0
      }
    }, React.createElement("table", {
      ref: function ref(table) {
        _this.table = table;
      },
      role: "presentation"
    }, React.createElement("colgroup", {
      ref: function ref(e) {
        _this.props.columnResize.colGroupHeader = e;
      },
      role: "presentation"
    }, this.props.cols), React.createElement("thead", {
      role: "presentation"
    }, this.props.headerRow, this.props.filterRow))));
  };

  return Header;
}(React.Component);

export { Header };